import { lazy } from 'react';

import { getDefaultAgendaImage } from '../../../../store/utils/create-event';
import { LanguagesAbbr, PageModule, Session, SessionPreview, SessionTypesFeatures } from '../../../../types/working-model';
import { getStylingOverrides } from '../../../live-event/utils';
import SessionCard from './agenda-session-card';
import { niceDateCalendar, niceTimeCalendar } from '../../../../utils/utils';
import { getHomepageDefaultLanguage } from '../../../../utils/get-language';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import { getLiveSessionsSelectedForDisplay } from './agenda-utils';
const EditorSessionCard = lazy(() => import('../../../admin/create/homepage/editor/agenda-editor/agenda-session-card'));

interface IGroupedSessions {
	heading: string;
	sessions: Array<Session | SessionPreview>;
}

interface CalendarBroadcastLayoutProps {
	sessionGroup: IGroupedSessions;
	module: PageModule;
	language: LanguagesAbbr;
	editor?: boolean;
	template: string;
	isAgendaPage: boolean;
}

export const CalendarBroadcast = ({
	sessionGroup,
	module,
	language,
	editor,
	template,
	isAgendaPage,
}: CalendarBroadcastLayoutProps): JSX.Element => {

	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const baseLanguage: LanguagesAbbr | null = getHomepageDefaultLanguage(workingEvent);
	const stylingOverrides = getStylingOverrides(module.styling_overrides);
	const sessionsDisplayed = getLiveSessionsSelectedForDisplay(sessionGroup.sessions, module, isAgendaPage);

	return sessionsDisplayed.length > 0
		? (
			<div key={sessionGroup.heading} className={'agenda-sessions-section'}>
				<h6>{niceDateCalendar(sessionGroup.heading, language)}</h6>
				{sessionsDisplayed.map((session, i) => (
					<div key={session.uuid} className={'agenda-sessions-section-row'}>
						{session.timestamp && SessionTypesFeatures[session.session_type].has_start_time && (
							<div className={'agenda-sessions-section-row-time'}>
								<span>{niceTimeCalendar(session.timestamp, language)}</span>
							</div>
						)}
						{editor ? (
							<EditorSessionCard
								baseLanguage={baseLanguage}
								language={language}
								session={session as Session}
								stylingOverrides={stylingOverrides}
								template={template}
								defaultImage={getDefaultAgendaImage(template, i)}
								isCalendarLayout={true}
							/>
						) : (
							<SessionCard
								session={session}
								stylingOverrides={stylingOverrides}
								template={template}
								defaultImage={getDefaultAgendaImage(template, i)}
								isCalendarLayout={true}
							/>
						)}

					</div>
				))}
			</div>
		)
		: <div></div>;
};
